import React from "react";

/** MUI */
import makeStyles from "@mui/styles/makeStyles";
import { Box } from "@mui/material";

const useStyles = makeStyles((theme) => ({
    root: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        position: "absolute",
        border: "1px solid #989722",
        zIndex: 9,
        borderImage: "linear-gradient(180deg,#fcff02,#989722) 30",
        borderWidth: 1,
        borderStyle: "solid",
        borderBottom:'none',
        overflow: "hidden",
        // boxShadow: "inset 0px 0px 25px rgb(252 255 2 / 25%)",
        pointerEvents: "none",
    },
    content: {
        top: 44,
        right: -33,
        padding: theme.spacing(0, 2),
        position: "absolute",
        fontSize: 12,
        transform: "rotateZ(45deg)",
        boxShadow: theme.shadows[5],
        fontWeight: "bold",
        textTransform: "uppercase",
        backgroundColor: "rgb(255 255 0 / 25%)",
        backgroundImage: "linear-gradient(8deg, #989722, #fcff02, #989722)",
        zIndex: 9,
        pointerEvents: "none",
        opacity:0.25
    },
}));

const ComponentIsUnderConstruction = () => {
    const classes = useStyles();
    return (
        <Box className={classes.root}>
            <Box className={classes.content}>{"W trakcie realizacji"}</Box>
        </Box>
    );
};

export default ComponentIsUnderConstruction;
